import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "./theme";
import AppRoutes from "@/routes/AppRoutes";
import ApiKeyDialog from "./components/ApiKeyDialog";
import { useEffect, useState } from "react";
import { client } from "./services/client.gen";
import { client as altgencyClient } from "./altgency_api/client.gen";

// TODO For debug purposes
// A revoir complètement ... revoir environnement IA local / prepro / production
export const api_base_url = process.env.REACT_APP_API_BASE_URL || "https://loanai.altgency.com/api";
export const altgency_base_url = "https://preprod.altgency.com/api/v1";

const App = () => {
  const getBaseApiKey = () => {
    return (
      new URLSearchParams(window.location.search).get("apiKey") ||
      localStorage.getItem("apiKey") ||
      null
    );
  };
  const [apiKey, setApiKey] = useState<string | null>(getBaseApiKey());
  useEffect(() => {
    console.log("Cookies:", document.cookie);
    if (apiKey) {
      localStorage.setItem("apiKey", apiKey);
      client.setConfig({
        baseUrl: api_base_url,
        auth: (auth: any) => apiKey,
        headers: {
          "x-api-key": apiKey,
        },
      });
    }
    altgencyClient.setConfig({
      baseUrl: altgency_base_url,
      credentials: "include",
    });
  }, []);

  const handleApiKeySet = (key: string) => {
    setApiKey(key);
    client.setConfig({
      baseUrl: api_base_url,
      headers: {
        "x-api-key": key,
      },
    });
  };

  return (
    <ThemeProvider theme={theme}>
      {apiKey == null && <ApiKeyDialog open={!apiKey} onSave={handleApiKeySet} />}
      <CssBaseline />
      <AppRoutes />
    </ThemeProvider>
  );
};

export default App;
